import { Component, OnInit, ChangeDetectionStrategy, input, output, inject, computed } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { COMPANY_INFO } from '@fitness-force/state';
import { DatePipe, SlicePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { AppErrors } from '@fitness-force/models';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
    SlicePipe
],
})
export class ErrorsComponent implements OnInit {
  store = inject(Store);
  translate = inject(TranslateService);
  private datePipe = inject(DatePipe);

  readonly showErrorPopup = input<boolean>(false, { alias: "visible" });
  readonly validationError = input<any[]>([], { alias: "errorData" });
  readonly error = input(new BehaviorSubject(null as AppErrors | null));
  readonly hideErrorPopup = output<Observable<boolean>>();

  localValidationErrors: any[] = [];

  allValidationErrors = computed(() => [
    ...this.validationError(),
    ...this.localValidationErrors
  ]);

  ngOnInit(): void {
    this.componentInit();
    this.setValidationErrorObject();
  }

  setValidationErrorObject() {
    const error = this.error();
    if (error?.value?.originalError) {
      if (error.value?.originalError.status) {
        if (Array.isArray(error.value?.originalError.error)) {
          for (
            let i = 0;
            i < error.value?.originalError.error.length;
            i++
          ) {
            if (
              error.value?.originalError.error[
                i
              ].errorCode.toLowerCase() == 'overlap'
            ) {
              this.showOverlapErrorMessage(
                error.value?.originalError.error[i]
              );
            } else {
              this.localValidationErrors.push(
                error.value?.originalError.error[i].errorMessage
              );
            }
          }
        } else {
          if (
            error.value?.originalError.error?.errorMessage
          ) {
            this.localValidationErrors.push(
              error.value?.originalError.error.errorMessage
            );
          } else if (error.value?.originalError.status == '403') {
            this.translate
              .get('common.errors.validations.FORBIDDEN')
              .subscribe((translation) => {
                this.localValidationErrors.push(translation);
              });
          }
        }
      } else if (error.value?.originalError.status == '400') {
        this.localValidationErrors.push('Error Occured');
      } else if (error.value?.originalError.status == '500') {
        this.localValidationErrors.push(error.value?.originalError.error);
      } else if (error.value?.originalError.status == '403') {
        this.translate
          .get('common.errors.validations.FORBIDDEN')
          .subscribe((translation) => {
            this.localValidationErrors.push(translation);
          });
      } else {
        this.localValidationErrors.push('Unknown Error');
      }
      //this.hideErrorPopup.emit(of(true));
    }
  }

  showOverlapErrorMessage(error: any) {
    const localStartDate = this.ConvertUTCToLocalDateTime(
      error.jsonObject.startDateTime
    );
    const localEndDate = this.ConvertUTCToLocalDateTime(
      error.jsonObject.endDateTime
    );
    const formattedStartDate = this.datePipe.transform(
      localStartDate,
      'MMM d, y, h:mm:ss a'
    );
    const formattedEndDate = this.datePipe.transform(
      localEndDate,
      'MMM d, y, h:mm:ss a'
    );
    this.translate
      .get('SCHEDULE.MSG.OVERLAP_MESSAGE', {
        type: error.jsonObject.identifier,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      })
      .subscribe((translation) => {
        this.localValidationErrors.push(translation);
      });
  }

  setHidePopup() {
    this.localValidationErrors = [];
    this.hideErrorPopup.emit(of(false));
  }

  componentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }

  ConvertUTCToLocalDateTime(date: Date | string): Date {
    const localDate = new Date(date);
    const offset = new Date().getTimezoneOffset();
    localDate.setMinutes(localDate.getMinutes() - offset);
    return localDate;
  }
}
